// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-0bd691a6]{height:100%;width:100%;padding:100px}.wrapper .wrapper-content[data-v-0bd691a6]{width:100%;height:100%;background-color:#fff;padding:20px 30px 0;border-radius:5px}", ""]);
// Exports
module.exports = exports;
